import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ComPlusAdminService } from '../complus-admin/complus-admin.service';

/** Site client : l'écran COM+ n'est accessible que si l'API l'autorise (réglage piloté depuis la version vendeur). */
export const comPlusAdminCustomerGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const access = await inject(ComPlusAdminService).getAccess();
  return access ? true : router.createUrlTree(['']);
};
